import React from "react";
import t from "./typography.module.css";

const ListHeader = ({ children }) => {
  return <p className={t.listHeader}>{children}</p>;
};

export default ListHeader;
